
<template>
    
        <mars-view id="recommendLawyerCard" class="recommend-lawyer-card" data-serverid="17291" data-area="recommend_lawyer_show"><mars-view class="title">
        律临精选律师推荐
    </mars-view><mars-view v-for="(lawyer, index) in lawyerList" :key="index" class="lawyer-card" @click.native="clickLawyer(lawyer)"><mars-view class="lawyer-avatar" :style="{'background-image': 'url(' + lawyer.lawyer_avatar + ')'}"><mars-view class="v-icon"></mars-view></mars-view><mars-view class="lawyer-info"><mars-view class="lawyer-name">
                {{ lawyer.lawyer_name }}
            </mars-view><mars-view v-if="lawyer.practice_year" class="lawyer-year">
                {{ lawyer.practice_year }}
            </mars-view><mars-view class="lawyer-firm">
                {{ lawyer.practice_company }}
            </mars-view></mars-view></mars-view></mars-view>
    
</template>

<script>
import { act } from '../../../static/utils/navigate';
import log from '../../../static/utils/ubcLog';
import { getConsultInfo } from '../../../static/utils/consultEvents.js';
export default {
  name: 'recommendLawyer',
  props: {
    lawyerList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    /**
     * 点击律师
     * @param {Object} lawyer
     */

    clickLawyer(lawyer) {
      // 律师推荐卡点击
      log.send && log.send({
        serverId: 17291,
        area: 'recommend_lawyer_icon_click',
        action: 'click'
      });
      getConsultInfo(lawyer.qc_core_no).then(res => {
        let url = res && res.consult_service && res.consult_service.target_url || '';
        url = url.replace('action=consult', '');
        act({
          type: 'url',
          target: `${url}&fr=note_recommend_lawyer`
        });
      });
    }
  }
};
</script>

<style scoped>
.recommend-lawyer-card {
  padding: 0.2rem 0.1rem;
  border-radius: 0.09rem;
  border: 1px solid #fff;
  background: linear-gradient(183deg, #e8effc 2.42%, #fff 26.85%);
  width: 1.96rem;
  height: 2.91rem;
  box-sizing: border-box;
}
.recommend-lawyer-card .title {
  color: #1e1f24;
  font-size: 0.16rem;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 1;
  margin-bottom: 0.24rem;
}
.recommend-lawyer-card .lawyer-card {
  display: flex;
  align-items: center;
}
.recommend-lawyer-card .lawyer-card .lawyer-avatar {
  width: 0.52rem;
  height: 0.52rem;
  border-radius: 0.52rem;
  background-color: lightgray;
  background-repeat: no-repeat;
  background-size: 90% 90%;
  background-position: center bottom;
  position: relative;
  flex-shrink: 0;
}
.recommend-lawyer-card .lawyer-card .lawyer-avatar .v-icon {
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  right: 0;
  bottom: -0.01rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/exporthome/light.png') no-repeat;
  background-size: 100% 100%;
}
.recommend-lawyer-card .lawyer-card .lawyer-info {
  color: #495266;
  font-size: 0.11rem;
  font-weight: 400;
  line-height: 1;
  margin-left: 0.08rem;
}
.recommend-lawyer-card .lawyer-card .lawyer-info .lawyer-name {
  color: #1e1f24;
  font-size: 0.14rem;
  font-weight: 600;
  line-height: 1;
}
.recommend-lawyer-card .lawyer-card .lawyer-info .lawyer-year,
.recommend-lawyer-card .lawyer-card .lawyer-info .lawyer-firm {
  margin-top: 0.06rem;
  max-width: 1.4rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.recommend-lawyer-card .lawyer-card:not(:last-child) {
  margin-bottom: 0.27rem;
}

</style>
